import { ModalRoot } from '@cian/ui-kit';
import * as React from 'react';

import { DEFAULT_VALUE } from './constants';
import { getNormalizedValue } from './utils';
import { useFiltersContext } from '../../../../packages/Filters/shared/utils/useFiltersContext';
import { getRangeValue, JsonQuery } from '../../../../packages/JsonQuery';
import { ETestId } from '../../../common/constants';
import { pluralize } from '../../../common/utils/pluralize';
import { Chip, ChipText } from '../../components/RedesignedFilters';
import { useAdaptModalToOpenedKeyboard } from '../../hooks/useAdaptModalToOpenedKeyboard';
import { useChip } from '../../hooks/useChip';
import { GuestsModalContainer } from '../GuestsModalContainer';

export const GuestsChipContainer = () => {
  const { jsonQuery } = useFiltersContext();
  const { open, onChipClick, onReset, onCloseWithReset, onApplyClick } = useChip(['beds_count', 'pets', 'kids']);

  const bedrooms = getRangeValue('beds_count')(jsonQuery);
  const guestsCount = getNormalizedValue(bedrooms?.gte) || DEFAULT_VALUE;
  const guestsLabel = `${guestsCount} ${pluralize(guestsCount, ['гость', 'гостя', 'гостей'])}`;

  const livingConditions = new JsonQuery(jsonQuery).getLivingConditions();
  const isSelected = guestsCount !== DEFAULT_VALUE || Boolean(livingConditions);

  const { handleModalRef } = useAdaptModalToOpenedKeyboard({ isModalOpen: open });

  return (
    <ModalRoot open={open} onOpenChange={onCloseWithReset}>
      <Chip onClick={onChipClick} isSelected={isSelected} testId={ETestId.RedesignedFiltersGuestsChip}>
        <ChipText>{guestsLabel}</ChipText>
      </Chip>
      <GuestsModalContainer
        onClose={onCloseWithReset}
        onResetClick={onReset}
        onApplyClick={onApplyClick}
        ref={handleModalRef}
      />
    </ModalRoot>
  );
};
